import { ICountingSourceDefinition } from '../types';

export const countingSources: ICountingSourceDefinition[] = [
  {
    id: 'paris',
    name: 'Open Data Paris',
    cityName: 'Paris',
    enabled: true,
    type: 'paris',
    recordsUrl:
      'https://opendata.paris.fr/api/explore/v2.1/catalog/datasets/comptage-velo-donnees-compteurs/records',
    dateField: 'date',
  },
  {
    id: 'nantes',
    name: 'Nantes Métropole Open Data',
    cityName: 'Nantes Métropole',
    enabled: true,
    type: 'nantes',
    recordsUrl:
      'https://data.nantesmetropole.fr/api/explore/v2.1/catalog/datasets/244400404_comptages-velo-nantes-metropole/records',
    dateField: 'jour',
  },
  {
    id: 'rennes',
    name: 'Rennes Métropole en accès libre',
    cityName: 'Rennes Métropole',
    enabled: true,
    type: 'ecoCounter',
    recordsUrl:
      'https://data.rennesmetropole.fr/api/explore/v2.1/catalog/datasets/eco-counter-data/records',
    dateField: 'date',
  },
  {
    id: 'tours-metropole',
    name: 'Tours Métropole Val de Loire Open Data',
    cityName: 'Tours Métropole Val de Loire',
    enabled: true,
    type: 'toursMetropole',
    recordsUrl:
      'https://data.tours-metropole.fr/api/explore/v2.1/catalog/datasets/comptage-velo-donnees-compteurs-syndicat-des-mobilites-de-touraine/records',
    dateField: 'date',
  },
  {
    id: 'toulouse',
    name: 'Toulouse Métropole Open Data',
    cityName: 'Toulouse Métropole',
    enabled: true,
    type: 'toulouse',
    recordsUrl:
      'https://data.toulouse-metropole.fr/api/explore/v2.1/catalog/datasets/comptage-velo-eco-counter/records',
    dateField: 'date',
  },
  {
    id: 'grand-lyon',
    name: 'Data Grand Lyon',
    cityName: 'Métropole de Lyon',
    enabled: true,
    type: 'grandLyon',
    recordsUrl:
      'https://data.grandlyon.com/fr/datapusher/ws/timeseries/pvo_patrimoine_voirie.pvocomptagemeasure/all.json',
    dateField: 'start_datetime',
  },
  {
    id: 'montpellier',
    name: 'Portail API Montpellier 3M',
    cityName: 'Montpellier Méditerranée Métropole',
    enabled: true,
    type: 'montpellier',
    recordsUrl: 'https://portail-api-data.montpellier3m.fr/ecocounter',
    dateField: 'intensity.metadata.TimeInstant.value',
  },
  {
    id: 'anglet',
    name: 'Open Data Pays Basque - Anglet',
    cityName: 'Anglet',
    enabled: true,
    type: 'anglet',
    recordsUrl:
      'https://anglet-opendatapaysbasque.opendatasoft.com/api/explore/v2.1/catalog/datasets/comptage-velo-donnees-compteurs-2026/records',
    dateField: 'date',
  },
  {
    id: 'saint-nazaire',
    name: 'Saint-Nazaire Agglo Open Data',
    cityName: 'Saint-Nazaire Agglo',
    enabled: true,
    type: 'saintNazaire',
    recordsUrl:
      'https://data.saintnazaireagglo.fr/api/explore/v2.1/catalog/datasets/ex-vue-personnalisee-comptage-velo-et-pedestre-donnees-compteurs/records',
    dateField: 'date',
  },
  {
    id: 'bordeaux',
    name: 'Bordeaux Métropole Open Data',
    cityName: 'Bordeaux Métropole',
    enabled: false,
    type: 'bordeaux',
    recordsUrl: 'https://data.bordeaux-metropole.fr/geojson?key=ci_captv_p&typename=ci_captv_p',
    dateField: 'date',
  },
];
